import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./homepage-brand-value.css";

interface JoinItemProps {
    paragraph: string;
    joinUrl: string;
}

export function JoinItem({ paragraph, joinUrl }: JoinItemProps): JSX.Element {
    return (
        <div className={styles.joinItem}>
            <p className={styles.joinParagraph}>{paragraph}</p>
            <a href={joinUrl} className={styles.joinUrl}>
                {gettext("homepage.module_value_props_join_button") // Join
                }
                <SVGIcon className={styles.arrowIcon} name={"arrow-icon"} />
            </a>
        </div>
    );
}

interface HomepageBrandValueItem {
    title: string;
    paragraphs: string[];
}

interface HomepageBrandValueItemProps {
    value: HomepageBrandValueItem;
    numeral: number;
}

export function HomepageBrandValueItem({
    value,
    numeral,
}: HomepageBrandValueItemProps): JSX.Element {
    return (
        <li className={styles.homepageBrandValueItem}>
            <h2 className={styles.numeral}> {numeral} </h2>
            <h4 className={styles.title}> {value.title} </h4>
            {value.paragraphs.map((paragraph) => (
                <p key={paragraph} className={styles.paragraph}>
                    {paragraph}
                </p>
            ))}
        </li>
    );
}

export interface HomepageBrandValueProps {
    items: HomepageBrandValueItem[];
    join_paragraph: string;
    join_url: string;
}

function HomepageBrandValue({
    items,
    join_paragraph: joinParagraph,
    join_url: joinUrl,
}: HomepageBrandValueProps): JSX.Element {
    return (
        <div className={styles.homepageBrandValueWrapper}>
            <ul className={styles.homepageBrandValuesList}>
                {items.map((value, index) => (
                    <HomepageBrandValueItem key={value.title} value={value} numeral={index + 1} />
                ))}
            </ul>
            <JoinItem paragraph={joinParagraph} joinUrl={joinUrl} />
        </div>
    );
}

export default HomepageBrandValue;
